module.exports = __webpack_public_path__ + "img/img1.0bd1dad2.jpg";